<template>
  <div class="my-baby">
    <div class="baby-list">
      <div :class="['baby-item', item.sex ? 'sex-girl' : 'sex-boy']"  v-for="(item, i) in babyList" :key="i">
        <div class="baby-info">
          <div class="name">{{ item.name }}</div>
          <!-- <div class="org">{{ item.organization }}</div> -->
          <div class="age">
            <span>{{
              item.sex == 2 ? "女" : item.sex == 1 ? "男" : "未提交"
            }}</span>
            <img
              v-if="item.sex === 2"
              src="../../assets/images/mine/my-bb-girl-ico.png"
              alt=""
            />
            <img
              v-else-if="item.sex === 1"
              src="../../assets/images/mine/my-bb-boy-ico.png"
              alt=""
            />
            <span>{{ item.age }}岁</span>
          </div>
        </div>
        <div class="baby-head">
          <img v-if="item.img" :src="item.img" alt="" />
          <img
            v-else-if="item.sex === 0 || item.sex === 1"
            src="../../assets/images/mine/boy-head.png"
            alt=""
          />
          <img
            v-else-if="item.sex === 2"
            src="../../assets/images/mine/girl-head.png"
            alt=""
          />
          <div class="edit" @click="editBaby(item.id)">编辑</div>
        </div>
      </div>
    </div>
    <div v-if="babyList.length<1" class="tips">
      请点击下方按钮添加学生
    </div>
    <div class="add-btn">
      <!-- <van-button :disabled="babyList.length === 1" @click="$router.push('/player/addbaby')" type="primary" size="normal" color="linear-gradient(to right, #1ebf5f, #37dc8d)">
        添加学生{{ `(${babyList.length} / 1)` }}
      </van-button> -->
      <!-- <div class="overallBetween frame" v-if="babyList.length <1">
        <div class="frame-title">如果您是初次参与，请点击新增</div>
        <div class="overallCenter frame-btn" @click="$router.push('/player/addbaby')">添加学生</div>
      </div> -->
      <div class="overallCenter frame-btn" style="margin: 0 auto;" v-if="babyList.length <1" @click="$router.push('/player/addbaby')">添加学生</div>
    </div>
  </div>
</template>

<script>
import { getAllUserBaby } from "@/utils/api/user";
export default {
  data() {
    return {
      babyList: []
      // {
      //   name: "姓名",
      //   age: "11",
      //   sex: 1,
      //   img: "",
      //   organization: "阳光艺术培训"
      // },
      // {
      //   name: "姓名",
      //   age: "11",
      //   sex: 0,
      //   img: "",
      //   organization: "阳光艺术培训"
      // }
    };
  },
  methods: {
    // 获取学生列表
    getMybaby() {
      getAllUserBaby().then((res) => {
        if (res.success) {
          this.babyList = res.data.map((e) => {
            return {
              name: e.name,
              age: e.age,
              sex: e.sex,
              organization: e.institutionName || "暂无报名服务单位",
              img: e.imgUrl,
              id: e.id
            };
          });
        }
      });
    },
    editBaby(id) {
      this.$router.push({
        path: "/player/addbaby",
        query: {
          id,
          mode: 1
        }
      });
    }
  },
  mounted() {
    this.getMybaby();
  }
};
</script>
<style lang="scss" scoped>
.my-baby {
  padding: 20px;
  .baby-list {
    width: 335px;
    .baby-item {
      width: 100%;
      height: 106px;
      display: flex;
      padding: 12px;
      margin-bottom: 15px;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 3px 6px rgba(5, 75, 27, 0.2);
      border-radius: 8px;
      .baby-info {
        width: 240px;
        text-align: left;
        .name {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          height: 25px;
          line-height: 25px;
        }
        .org {
          font-size: 12px;
          line-height: 17px;
          color: #666;
          margin-top: 4px;
        }
        .age {
          font-size: 14px;
          line-height: 20px;
          color: #999;
          margin-top: 15px;
          display: flex;
          align-items: center;
          img {
            margin-left: 7px;
            margin-right: 13px;
          }
        }
      }
      .baby-head {
        display: flex;
        justify-content: center;
        margin-right: 5px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 106px;
        padding: 12px 0;
        img {
          height: 54px;
          width: 54px;
        }
        div.edit {
          height: 20px;
          line-height: 21px;
          font-size: 12px;
          color: #fff;
          background: linear-gradient(to right, #1ebf5f, #37dc8d);
          border-radius: 10px;
          width: 60px;
        }
      }
    }
  }
  .tips {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8E8E94;
    text-align: left;
    margin-top: 9px;
    margin-bottom: 70px;
  }
  .tipsImg{
    width: 146px;
    height: 120px;
    margin: 0 auto;
    margin-top: 50px;
  }
}
</style>
<style lang="scss">
.my-baby {
  .add-btn {
    position: fixed;
    bottom: 30px;
    width: 100%;
    height: 50px;
    left: 0;
    .van-button {
      border-radius: 21px;
      height: 42px;
      width: 137px;
      font-size: 12px;
    }
    .frame{
      width: 345px;
      height: 50px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      margin: 0 auto;
    }
    .frame-title{
      margin-left: 18px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
    .frame-btn{
      width: 97px;
      height: 35px;
      background: #83E38F;
      border-radius: 18px;
      margin-right: 12px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}
</style>
